import { AbstractControl, ValidationErrors, Validator, ValidatorFn } from "@angular/forms";
import { plainToClass } from 'class-transformer';
import { DocumenttypeDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/documenttype-display-model";
import { DocumentDisplayModel } from "@/api/models/ace/xFound/Portal/Core/CAQ/Models/document-display-model";
import { GlobalEnumsAceRechtsform } from "@/api/models/ace/xFound/Portal/Core/Entities/global-enums-ace-rechtsform";

export class AttachmentsValidator implements Validator{
    constructor(public documentType: DocumenttypeDisplayModel | null | undefined, public rechtsform: GlobalEnumsAceRechtsform | null | undefined){

    }
    validate(attachments: AbstractControl): ValidationErrors | null {
        if(!attachments.value){
            return {required: true};
        }

        let mappedAttachments: DocumentDisplayModel[] = attachments.value;
        mappedAttachments = mappedAttachments.map(attachment => plainToClass(DocumentDisplayModel, attachment));
        
        if(mappedAttachments.find(attachment => !attachment.documententyp?.erlaubteDateiendungen?.includes(this.fileExtension(attachment))))
            return {invalidFileExtension: true};

        if(this.documentType && this.isUploadRequiredForRechtsform(this.documentType, this.rechtsform) && !mappedAttachments.find(attachment => attachment.documententyp?.documenttypeId == this.documentType?.documenttypeId))
            return {missingDocuments: true};

        return null;
    }

    public isUploadRequiredForRechtsform(documentType: DocumenttypeDisplayModel, rechtsform: number | null | undefined): boolean{
        return (documentType.rechtsformen == null || documentType.rechtsformen.length < 1 || (rechtsform != null && documentType.rechtsformen.includes(rechtsform))) && documentType.isUploadRequired == true;
    }

    public fileExtension(document: DocumentDisplayModel): string {
        if(document.name && document.name.indexOf(".") != -1)
        {
            return document.name.substr(document.name.lastIndexOf(".") + 1);
        }
        return "";
    }
}

export function attachmentsValidator(documentType: DocumenttypeDisplayModel | null | undefined, rechtsform: GlobalEnumsAceRechtsform | null | undefined): ValidatorFn {
    let validator: AttachmentsValidator = new AttachmentsValidator(documentType, rechtsform);

    return validator.validate.bind(validator);
}